import React from "react";
import {compose} from "redux";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import {Image, ScrollView, StyleSheet, Text, TouchableOpacity, View} from "react-native";
import ChevronDroitMediumPicto from "../Picto/ChevronDroitMediumPicto";
import {signOut} from "../../Store/Reducers/AuthReducer";
import {getAppConfigJsonValue} from "../../API/API";


class ReglageScreen extends React.Component{
    constructor(props) {
        super(props);
        this.navigateToApparence= this.navigateToApparence.bind(this);
        this.navigateToLangue = this.navigateToLangue.bind(this);
        this.navigateToConfidentialite = this.navigateToConfidentialite.bind(this);
        this.navigateToCache = this.navigateToCache.bind(this);
        this.navigateToNotif = this.navigateToNotif.bind(this);
        this.navigateToCGU = this.navigateToCGU.bind(this);
        this.deconnexion = this.deconnexion.bind(this);

	this.state = {
	  loading: true,
	  cgu: null
	};
    }

    componentDidMount() {
        this._setHeader();
        getAppConfigJsonValue("cgu").then((cgu) => {
          this.setState({loading: false, cgu})
        })
    }

    componentDidUpdate() {
        this._setHeader();
    }

    navigateToApparence(){
        this.props.navigation.navigate("Apparence",{});
    }

    navigateToLangue(){
        this.props.navigation.navigate("Langue",{});
    }

    navigateToConfidentialite(){
        this.props.navigation.navigate("Confidentialite",{});
    }

    navigateToCache(){
        this.props.navigation.navigate("SWCache",{});
    }

    navigateToNotif(){
        this.props.navigation.navigate("SWNotif",{});
    }

    navigateToCGU(){
        this.props.navigation.navigate("CGU",{});
    }

    deconnexion(){
        // const action = {'type': 'SIGN_OUT', 'value': ""};
        // this.props.dispatch(action);
        // this.props.navigation.navigate("Home",{});
      signOut()(this.props.dispatch).then(() => {
        this.props.navigation.navigate("Home",{});
      })
    }

    _setHeader(){
        const styleHeaderGlobalWhite = {
            fontFamily: this.props.theme.fonts.title,
            backgroundColor : this.props.theme.colors.primary.White.value,
            height:80
        }  ;
        this.props.navigation.setOptions(
            {
                headerTitleAlign: "center",
                headerStyle: styleHeaderGlobalWhite,
                headerTitleStyle:{textTransform: 'capitalize'},
                title : this.props.t('Reglage'),
                headerLeft : ()=><TouchableOpacity onPress={this.props.navigation.goBack}>
                    <Image resizeMode={"contain"} style={{width:20,height: 20,marginLeft:20, flex: 1}} source={this.props.theme.pictos.chevronGaucheMediumPicto.light} />
                </TouchableOpacity>
            }
        );
    }

    render() {
        const styles= StyleSheet.create({
           container:{
               paddingVertical:12,
               paddingHorizontal:20,
               flexDirection:"row",
               justifyContent:"space-between",
               alignItems:"center",
               borderBottomWidth:1,
               borderBottomColor:this.props.theme.colors.tertiary.black13.value,
               backgroundColor:this.props.theme.colors.primary.White.value
           } ,
            text:{
                fontFamily:this.props.theme.fonts.text_bold,
                color : this.props.theme.colors.tertiary.black3.value,
                fontSize:15,
                fontWeight:500
            },
            picto:{
                width:10,
                marginRight:10
            }
        });
        return (
            <ScrollView>
                <TouchableOpacity onPress={this.navigateToApparence}>
                    <View style={styles.container}>
                        <Text style={styles.text}>{this.props.t("Apparence")}</Text>
                        <ChevronDroitMediumPicto style={styles.picto} isHeader={true} />
                    </View>
                </TouchableOpacity>

		{
		// deactivate NIP
		false &&
                <TouchableOpacity onPress={this.navigateToConfidentialite}>
                    <View style={styles.container}>
                        <Text style={styles.text}>{this.props.t("Confidentialité")}</Text>
                        <ChevronDroitMediumPicto style={styles.picto} isHeader={true} />
                    </View>
                </TouchableOpacity>
		}

                <TouchableOpacity onPress={this.navigateToLangue}>
                    <View style={styles.container}>
                        <Text style={styles.text}>{this.props.t("Langue")}</Text>
                        <ChevronDroitMediumPicto style={styles.picto} isHeader={true} />
                    </View>
                </TouchableOpacity>

                <TouchableOpacity onPress={this.navigateToCache}>
                    <View style={styles.container}>
                        <Text style={styles.text}>{this.props.t("Cache")}</Text>
                        <ChevronDroitMediumPicto style={styles.picto} isHeader={true} />
                    </View>
                </TouchableOpacity>

                <TouchableOpacity onPress={this.navigateToNotif}>
                    <View style={styles.container}>
                        <Text style={styles.text}>{this.props.t("Notification")}</Text>
                        <ChevronDroitMediumPicto style={styles.picto} isHeader={true} />
                    </View>
                </TouchableOpacity>

		{
                  this.state.loading === false && this.state.cgu.last_version_at !== null &&
                  <TouchableOpacity onPress={this.navigateToCGU}>
                      <View style={styles.container}>
                          <Text style={styles.text}>{this.props.t("CGU")}</Text>
                          <ChevronDroitMediumPicto style={styles.picto} isHeader={true} />
                      </View>
                  </TouchableOpacity>
		}

                <TouchableOpacity>
                    <View style={styles.container}>
                        <Text style={styles.text}>{this.props.t("Contacter l'administrateur")}</Text>
                        <ChevronDroitMediumPicto style={styles.picto} isHeader={true} />
                    </View>
                </TouchableOpacity>

                <TouchableOpacity onPress={this.deconnexion}>
                    <View style={styles.container}>
                        <Text style={[styles.text,{color:this.props.theme.colors.primary.error.value}]}>{this.props.t("Deconnexion")}</Text>
                    </View>
                </TouchableOpacity>
            </ScrollView>
        );
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme, auth : state.AuthReducer};
}

export default compose(connect(mapStateToProps),withTranslation())(ReglageScreen);
